import styles from "../../public/css/menu/menu.module.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Head from "../../components/Head";
import Modal from "../../components/modal/Modal";
import * as common from "../../common/commonFunction";
import commonSession from "../../common/commonSession";
import { useSpring, animated } from "react-spring";
import { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";
import {
  P01_01_01_NAME,
  P01_01_02_NAME,
  LOGIN_ALERT1
} from "../../lib/global_variable";
import { isMobile } from "react-device-detect";
import Link from "next/link";
import { FaUserCircle } from "react-icons/fa";

export default function Index() {
  const sessionInfo = commonSession.getSession();
  console.log(sessionInfo);
  const nickName = sessionInfo?.userId || "내 이메일";

  // `react-spring`을 이용하여 5초 간격으로 애니메이션 효과를 적용
  const [isGlowing, setIsGlowing] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsGlowing((prev) => !prev);
    }, 5000); // 5초 간격으로 애니메이션 토글
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Head />
      <Header />
      <div className={styles.container}>
        {/* 사용자 아이콘과 닉네임 표시 */}
        <section
          className={`${styles.userInfo} ${isGlowing ? styles.glow : ""}`}
        >
          <FaUserCircle size={40} />
          <span className={styles.userNickname}>{nickName}</span>
        </section>

        <main className={styles.main}>
          <section className={styles.menuCard}>
            <Link href="/mypage/MymbId" passHref>
              <div className={styles.menuText}>
                <h2>내 정보</h2>
                <p>비밀번호나 계좌번호를 수정할 수 있어요!</p>
              </div>
            </Link>
          </section>

          <section className={styles.menuCard}>
            <Link href="/mypage/NFT" passHref>
              <div className={styles.menuText}>
                <h2>NFT</h2>
                <p>내게 발급된 NFT들을 볼 수 있어요!</p>
              </div>
            </Link>
          </section>
          <section className={styles.menuCard}>
            <Link href="/settlement/MySettlementList" passHref>
              <div className={styles.menuText}>
                <h2>내 정산금</h2>
                <p>내 펀딩 항목의 정산금 현황/신청을 볼 수 있어요!</p>
              </div>
            </Link>
          </section>
          <section className={styles.menuCard}>
            <Link href="/reward/RewardList" passHref>
              <div className={styles.menuText}>
                <h2>내 리워드</h2>
                <p>내 활동 리워드를 볼 수 있어요!</p>
              </div>
            </Link>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
}
